import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Grid, Modal } from 'semantic-ui-react';

// Actions
import { updateQueryString } from 'services/router/actions';
import { payrollExportDeleteRequested } from 'services/payrollExports/actions';

import { AppState } from 'services/types';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// @ts-ignore
import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorAlert from 'components/ErrorAlert';
import SubmittingButton from 'components/SubmittingButton';

// Components
import TimesheetSubmissionsRevertMessage from '../TimesheetSubmissionsRevertMessage';

interface ConnectedProps {
    isOpen?: boolean;
    id?: number;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
    deletePayrollExport: typeof payrollExportDeleteRequested;
}

type Props = ConnectedProps & DispatchProps;

export class TimesheetSubmissionsRevertModal extends React.PureComponent<Props> {
    handleClose = (): void => {
        const { updateQueryString: updateQuery } = this.props;

        updateQuery({
            selectedPayrollExportId: undefined,
            timesheetSubmissionsRevertModal: undefined
        });
    };

    handleSubmit = (): void => {
        const { deletePayrollExport, id } = this.props;

        if (id) deletePayrollExport(id);
    };

    render(): React.ReactElement | null {
        const { isOpen, id } = this.props;

        if (!id) return null;

        return (
            <Modal
                size="tiny"
                open={isOpen}
                centered={false}
                onClose={this.handleClose}
                closeIcon
            >
                <ErrorBoundary
                    namespace="TimesheetSubmissionsRevertModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Revert Payroll Submission</Modal.Header>
                    <Modal.Content>
                        <Grid>
                            <Grid.Column>
                                <TimesheetSubmissionsRevertMessage id={id} />
                            </Grid.Column>
                        </Grid>
                        <ErrorAlert namespace="PAYROLL_EXPORT_DELETE" />
                        <Grid centered>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="button"
                                    onClick={this.handleClose}
                                    fluid
                                    basic
                                    primary
                                >
                                    Cancel
                                </Button>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <SubmittingButton
                                    type="submit"
                                    namespace="PAYROLL_EXPORT_DELETE"
                                    negative
                                    fluid
                                    onClick={this.handleSubmit}
                                >
                                    Revert
                                </SubmittingButton>
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    unknown,
    ConnectedProps
>({
    isOpen: makeSelectQueryStringBooleanValue(
        'timesheetSubmissionsRevertModal'
    ),
    id: makeSelectQueryStringNumberValue('selectedPayrollExportId')
});

export default connect(mapStateToProps, {
    updateQueryString,
    deletePayrollExport: payrollExportDeleteRequested
})(TimesheetSubmissionsRevertModal);
